import React from "react";
import ParkEnterIdle from "../../ParkEnterIdle";

const Screen1 = () => {
    return <ParkEnterIdle />;
};

export default Screen1;
